import { useCallback, useEffect, useRef, useState } from 'react';

import { getFinanceStatus as getFinanceStatusAPI } from 'PrivateAPI';

import { captureExceptionWithTeam } from 'Utilities/captureException/captureExceptionWithTeam';
import { TEAM } from 'Utilities/constants';

import { FinanceStatusResponse } from 'Containers/app/payments/Payments.types';

export const useGetFinanceStatus = (): {
  data: FinanceStatusResponse | null | undefined;
  getFinanceStatus: (dpEnquiryId: number) => Promise<void>;
  isFetched: boolean;
} => {
  const [data, setData] = useState<FinanceStatusResponse | null>();
  const [isFetched, setIsFetched] = useState<boolean>(false);
  const cancelled = useRef(false);

  const resolve = useCallback((newData: typeof data) => {
    if (cancelled.current) {
      return;
    }

    setData(newData);
  }, []);

  const getFinanceStatus = useCallback(async (dpEnquiryId: number) => {
    try {
      const response = await getFinanceStatusAPI(dpEnquiryId, undefined);

      if (response.status === 'success') {
        resolve(response.data);
      }
    } catch (err) {
      resolve(null);

      if (err && (err as { message: string }).message === 'motorway.payments.no_post_sale_offer') {
        return;
      }

      captureExceptionWithTeam(
        err,
        TEAM.PAYMENTS_FE,
        {
          extra: {
            dpEnquiryId,
          },
          tags: {
            fetch: 'useFinanceStatus',
          },
        },
      );
    } finally {
      setIsFetched(true);
    }
  }, [resolve]);

  useEffect(() => () => {
    cancelled.current = true;
  }, []);

  return {
    data,
    getFinanceStatus,
    isFetched,
  };
};
